import React from "react";
import { useFormContext, Controller } from "react-hook-form";
import { useTranslation } from "react-i18next";
import DatePicker from "src/components/DatePicker";

const CreatedDateTo = () => {
  const { control } = useFormContext();
  const { t } = useTranslation("orders");

  return (
    <Controller
      render={({ ref, ...props }) => (
        <DatePicker
          endDate
          label={t("list_filter.created_date_to_label")}
          fullWidth
          {...props}
          inputRef={ref}
        />
      )}
      defaultValue=""
      name="createdDateTo"
      control={control}
    />
  );
};

export default CreatedDateTo;
